// project-imports
import { getRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - METRICS ||============================== //

export async function handleMetrics(action: APIAction) {
  switch (action.method) {
    case 'resume':
      return getRequest('/metrics/resume');
    case 'resume-packs':
      return getRequest('/metrics/resume-packs');
    // case 'create':
    //   return postRequest('/metrics', action.data);
    case 'read':
      return getRequest(`/metrics?type=${action.data.type}&entity=${action.data.entity}&entity-id=${action.data.entityId}`);
    // case 'update':
    //   return putRequest(`/metrics/${action.id}`, action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleMetrics] - Unknown method');
      break;
  }
}
